function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgBeer = function SvgBeer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C63C22"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E231D"
    },
    d: "M296.703,139.216l-96.66-96.678L95.112,242.358l54.626,54.626C231.181,296.318,297,230.1,297,148.5 C297,145.381,296.892,142.288,296.703,139.216z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M207.444,99.107c9.143,0,16.556-7.412,16.556-16.556s-7.412-16.556-16.556-16.556 c-0.233,0-0.459,0.025-0.689,0.035c0.446-1.863,0.689-3.805,0.689-5.805c0-13.715-11.118-24.833-24.833-24.833 c-8.456,0-15.919,4.23-20.404,10.685c-2.92-2.582-6.747-4.163-10.951-4.163c-3.669,0-7.048,1.208-9.793,3.228 c-4.538-5.926-11.683-9.751-19.724-9.751c-10.476,0-19.43,6.491-23.079,15.667c-2.156-1.028-4.559-1.62-7.106-1.62 C82.412,49.44,75,56.852,75,65.996s7.412,16.556,16.556,16.556L207.444,99.107z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D5D9"
    },
    d: "M207.444,65.996c-0.233,0-0.459,0.025-0.689,0.035c0.446-1.863,0.689-3.805,0.689-5.804 c0-13.715-11.118-24.833-24.833-24.833c-8.455,0-15.919,4.23-20.404,10.685c-2.92-2.583-6.747-4.163-10.951-4.163 c-0.882,0-1.745,0.073-2.589,0.208V90.71l58.777,8.397c9.143,0,16.556-7.412,16.556-16.556S216.588,65.996,207.444,65.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0DEB4"
    },
    d: "M238.282,115.5H206.25v-33H90.75v148.792c0,8.952,7.257,16.208,16.208,16.208h83.083 c8.952,0,16.208-7.257,16.208-16.208V198h32.032c5.091,0,9.218-4.127,9.218-9.218v-64.064 C247.5,119.627,243.373,115.5,238.282,115.5z M235.853,177.032c0,3.71-3.008,6.718-6.718,6.718h-19.488v-54h19.488 c3.71,0,6.718,3.008,6.718,6.718V177.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8C49C"
    },
    d: "M238.282,115.5H206.25v-33h-57.583v165h41.375c8.952,0,16.208-7.257,16.208-16.208V198h32.032 c5.091,0,9.218-4.127,9.218-9.218v-64.064C247.5,119.627,243.373,115.5,238.282,115.5z M235.853,177.032 c0,3.71-3.008,6.718-6.718,6.718h-19.488v-54h19.488c3.71,0,6.718,3.008,6.718,6.718V177.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA800"
    },
    d: "M111.814,237.857h73.372c7.905,0,14.314-6.409,14.314-14.314v-92.4h-102v92.4 C97.5,231.449,103.909,237.857,111.814,237.857z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE8400"
    },
    d: "M148.667,131.143v106.714h36.519c7.905,0,14.314-6.409,14.314-14.314v-92.4H148.667z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beer.a266a13f.svg";
export { ForwardRef as ReactComponent };